var _rect, _rect2, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLingpeijianbiao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.5,
    width: 13,
    height: 13,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2,
    width: 12,
    height: 2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6057 5.7859L12.4613 9L10.6057 12.2141L6.89434 12.2141L5.03868 9L6.89434 5.7859L10.6057 5.7859Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 9,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 9,
    r: 1.5,
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLingpeijianbiao);
export default __webpack_public_path__ + "static/media/lingpeijianbiao.ea9eaa820022ef6ba1013b82af323c20.svg";
export { ForwardRef as ReactComponent };